import axios, { AxiosInstance, AxiosError } from 'axios';
import { is401UnauthorizedError } from '../constant/utils';


const baseUrl = import.meta.env.VITE_MINDRIGHT_API_ENDPOINT;
console.log('base url ==>', baseUrl);

interface ApiClient extends AxiosInstance {
  defaults: AxiosInstance['defaults'] & {
    headers: {
      common: {
        Authorization?: string;
      };
    };
  };
}

export const client = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
}) as ApiClient;

const setupResponseInterceptor = (axiosClient: ApiClient): (() => void) => {
  const interceptor = axiosClient.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (is401UnauthorizedError(error)) {
        // history.push('/logout');
      }
      return Promise.reject(error);
    }
  );
  return () => axiosClient.interceptors.response.eject(interceptor);
};

export const setAuthHeader = (token: string): void => {
  if (!token) {
    console.warn('No token provided to setAuthHeader');
    return;
  }
  client.defaults.headers.common.Authorization = `Bearer ${token}`;
};

setupResponseInterceptor(client);

export const removeAuthHeader = (): void => {
  delete client.defaults.headers.common.Authorization;
};